<div class="p-grid">
  <div
    class="p-col-3 base-menu-wrapper"
    style="height: auto"
    [ngStyle]="{ width: isPanelOpen ? '25%' : '1%' }"
    [class.open-panel]="isPanelOpen"
  >
    <p-tree
      *ngIf="isPanelOpen"
      [value]="items"
      [selectionMode]="selectionMode"
      [(selection)]="selectedItem"
      (onNodeSelect)="nodeSelect($event)"
    ></p-tree>

    <div class="arrow-wrapper">
      <i
        class="arrow pi pi-chevron-left"
        *ngIf="isPanelOpen"
        (click)="isPanelOpen = !isPanelOpen"
      ></i>
      <i
        class="arrow pi pi-chevron-right"
        *ngIf="!isPanelOpen"
        (click)="isPanelOpen = !isPanelOpen"
      ></i>
    </div>
  </div>

  <div class="p-col-9" [ngStyle]="{ width: isPanelOpen ? '75%' : '95%' }">
    <div class="c-card">
      <ng-template appBmPanel></ng-template>
    </div>
    <div class="p-d-flex p-jc-between p-mt-4" *ngIf="showNavButtons">
      <div>
        <p-button (click)="triggerNavigate('prev')" *ngIf="index > 0"
          >Prev</p-button
        >
      </div>
      <div>
        <p-button
          (click)="triggerNavigate('next')"
          *ngIf="index < totalItems - 1"
          >Next</p-button
        >
      </div>
    </div>
  </div>
</div>
